import React from "react";
import { Helmet } from "react-helmet";

function HelmetTags({ title, desc, route }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={`https://cbselearn.vercel.app/${route}`} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta
        property="og:url"
        content={`https://cbselearn.vercel.app/${route}`}
      />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:site"
        content={`https://cbselearn.vercel.app/${route}`}
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="10 minutes" />
    </Helmet>
  );
}

export default HelmetTags;
